import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=e1c1707e&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=e1c1707e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c1707e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1c1707e')) {
      api.createRecord('e1c1707e', component.options)
    } else {
      api.reload('e1c1707e', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=e1c1707e&scoped=true&", function () {
      api.rerender('e1c1707e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-84M1dJx5PSa0X/JS/comp/PopupBox.vue"
export default component.exports